module.exports = __webpack_public_path__ + "static/media/vaccine-dev.ecb27f5a.png";